import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { useSettlementSheetStore } from '@/stores/settlement-sheet';
import type { EventDetailsContext } from '@/router/routes';
import { UNAVAILABLE_SETTLEMENT_QUERY } from '@/router/unavailableSettlement';

const findSettlementArtist = async (eventId: number, settlementId: number): Promise<string | undefined> => {
  try {
    const owner = await useSettlementSheetStore().fetchSettlementArtist(settlementId);

    return owner?.eventIds.includes(eventId) ? owner.artistId : undefined;
  } catch {
    // AppSchema answers an archived settlement with NotFoundError, so a rejection is the expected stale bookmark.
    return undefined;
  }
};

/** Sends the legacy event-artist settlement URL to the Settlement tab of the settlement's artist. */
export const redirectToSettlementTab = (context: EventDetailsContext) => async (to: RouteLocationNormalized): Promise<RouteLocationRaw> => {
  const { eventId, settlementId } = to.params;

  const artistId = await findSettlementArtist(Number(eventId), Number(settlementId));
  if (!artistId) {
    // vue-router runs route-level `beforeEnter` outside the app context, so `useGettext` cannot inject here.
    return { name: `${context}.Event.ArtistIndex`, params: { eventId }, query: UNAVAILABLE_SETTLEMENT_QUERY };
  }

  return { name: `${context}.Event.Artist.Settlement`, params: { eventId, artistId, settlementId }, query: to.query, hash: to.hash };
};
